import axios from 'axios';
import { buildApiUrlLink } from 'projects/sharedComponents/src/services/links/linkBuilder';

export const evTrackUrl = buildApiUrlLink('/evtrk');

export interface TrackClickData {
  eventCategory: string;
  eventAction: string;
  eventLabel?: string;
  eventValue?: number;
  petNum?: number;
  handle?: string;
}
/**
 * Tracks a click event through evtrk
 * @param {TrackClickData} eventData - click event data
 */
export async function trackClick(eventData: TrackClickData): Promise<void> {
  const dataWithScreenWidth = JSON.stringify({
    ...eventData,
    screenWidth: window.screen.width,
  });

  if (navigator.sendBeacon) {
    navigator.sendBeacon(evTrackUrl, dataWithScreenWidth);
  } else {
    await axios.post(evTrackUrl, dataWithScreenWidth, {
      headers: { 'Content-Type': 'text/plain' },
      withCredentials: true,
    });
  }
}
